var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{style:({
    width: this.width,
  }),attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"clearable":""},on:{"input":function($event){return _vm.$emit('input', $event)},"change":_vm.changeHanlder}},[_c('el-option',{key:false,attrs:{"label":_vm.falseLabel,"value":false}}),_vm._v(" "),_c('el-option',{key:true,attrs:{"label":_vm.trueLabel,"value":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e73c38a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qs/BooleanSelect.vue
// module id = null
// module chunks = 